// Module
var code = "<div ng-include=\"'app/components/core/blocks/header.html'\"> </div> <ui-view/> ";
// Exports
module.exports = code;